// extracted by mini-css-extract-plugin
export default {"makeTransparent":"TransitionStyles_makeTransparent__929oj","instantTransparent":"TransitionStyles_instantTransparent__TUOZf","removeDisplay":"TransitionStyles_removeDisplay__qq72L"};